import styled from 'styled-components';

export const ConversationTypeContainer = styled.div`
    display: flex;
    height: 32px;
    padding: 16px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 8px;
    ${props => props.theme.fonts.variant.bold()}
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    color: ${(props) => props.theme.colors.davysGrey};
    border: 1px solid ${(props) => props.theme.colors.davysGrey};
    background: ${(props) => props.theme.colors.tableHeaderBg};
`;
